import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3)
  },
  grid: {
    marginTop: theme.spacing(2)
  },
  spinner: {
    minHeight: '20rem',
    marginTop: theme.spacing(2)
  }
}));